import { profileEn } from "@/module/Profile/locale/ProfileLocaleEn.js";
import { register } from "../../module/Register/locale/register.en.js";
import { pdpa } from '@/module/Static/locale/Pdpa/pdpa.en.js'
import { login } from '@/module/Login/locale/login.en';

import { changePassword } from '@/module/ChangePassword/Locale/changePasswordLocaleEn.js'
import { myprofile } from "@/module/MyProfile/locale/myprofile.en.js";
import { searchList } from "@/module/SearchList/locale/SearchListLocaleEn.js";
import { contactUS } from "@/module/ContactUs/Locale/contactUs.en.js";
import { language } from "@/module/LanguagePage/Locale/language.en.js";
import { privacySetting } from "@/module/PrivacySetting/Locale/privacySetting.en.js";

export const en = {
    default: {
        search: 'SEARCH',
        confirm: 'CONFIRM',
        ok: 'OK',
        cancel: 'CANCEL',
        close: 'Close',
        submit: 'Submit',
    },

    my_account: 'MY ACCOUNT',
    profile: profileEn,
    register: register,
    pdpa: pdpa,
    login: login,
    changePassword: changePassword,
    myprofile: myprofile,
    searchList: searchList,
    contactUS: contactUS,
    language: language,
    privacySetting: privacySetting,
    date: {
        days: 'day',
        months: 'month',
        years: 'year',
        minutes: 'minute',
        minutes_short: 'min',
        hours: 'hour',
        hours_short: 'hr',
        date_flase: 'Please select your birthday.',
        month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        month_full_arr: [{ strvalue: "01", strtext: 'January' },
        { strvalue: '02', strtext: 'February' },
        { strvalue: '03', strtext: 'March' },
        { strvalue: '04', strtext: 'April' },
        { strvalue: '05', strtext: 'May' },
        { strvalue: '06', strtext: 'June' },
        { strvalue: '07', strtext: 'July' },
        { strvalue: '08', strtext: 'August' },
        { strvalue: '09', strtext: 'September' },
        { strvalue: '10', strtext: 'October' },
        { strvalue: '11', strtext: 'November' },
        { strvalue: '12', strtext: 'December' }]
    },
    redeem_button: {
        default: 'Redeem',
        none: '',
        soldOut: 'Sorry, This reward is reaching redemption limit.',
        soldOutBuy: 'Sorry, This reward is reaching redemption limit.',
        maxPerPerson: 'Sorry, You have already redeemed this reward.',
        redeemCoolDown: 'This campaign has been used for this period.',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This campaign requires user action before redemption, please review the conditions first.',
        campaignExpired: 'Campaign has expired.',
        campaignExpiredBuy: 'Campaign has expired.',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: 'Your point are not enough to redeem this campaign.',
        notSupport: 'This campaign is not support.'
    },
    confirm_redeem: {
        confirm: "Confirm",
        cancel: "Cancel",

        headline: 'Confirm',
        default: 'Confirm to redeem',
        defualt_have_time: 'Serial will available for {0} after confirm',
        delivery: 'Please enter shipping information to redeem',
        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm to redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm to redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'This will redirect to website after confirm',
    },
    purchase: {
        show_code: 'view code',
        code_expired: 'This serial has expired.',

        delivery: 'Product will be mailed based on Campaign Condition.',
        shipped: 'The Product has been delivered.',
        parcel_no: 'ParcelNo',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',
    },
    serial: {
        close_btn: 'Close',
        default_privilege_message: 'As design',
        show_code_at_shop: 'Please show code below to claim your privilege',

        delivery: 'Product will be mailed based on Campaign Condition.',

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        copy_code: 'Copy Code',

        expire_in: 'Expire in ',
        code_expired: 'This serial has expired.',

        redeem_on: 'Redeem on {0}'
    },
    shipping: {
        headline: 'Shipping address',

        firstname: {
            name: 'Firstname',
            placeholder: 'Firstname',
            required: 'Please enter firstname',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Lastname',
            placeholder: 'Lastname',
            required: 'Please enter lastname',
            too_short: '',
            invalid: '',
        },
        addressName: {
            name: 'Address name',
            placeholder: 'Address name',
            required: 'Please enter address name',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'Address',
            placeholder: 'Address',
            required: 'Please enter address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Contact number',
            placeholder: 'Contact number',
            required: 'Contact number',
            too_short: 'Contact number must be {0} digits',
            invalid: 'Incorrect contact number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Zipcode',
            placeholder: 'Zipcode',
            required: 'Please enter zipcode',
            too_short: 'Zipcode must be {0} digits',
            invalid: 'Invalid zipcode',
        },
        subdistrict: {
            name: 'Sub district',
            placeholder: 'Please selece sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please selece district',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please selece province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },

        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',
    },
    tax: {
        personType: {
            name: 'ออกในนาม',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        title: {
            name: 'คำนำหน้าชื่อ',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        companyName: {
            name: 'ชื่อ / บริษัท',
            placeholder: 'ชื่อ / บริษัท',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        building: {
            name: 'อาคาร',
            placeholder: 'อาคาร',
            required: '',
            too_short: '',
            invalid: '',
        },
        room: {
            name: 'เลขที่ห้อง',
            placeholder: 'เลขที่ห้อง',
            required: '',
            too_short: '',
            invalid: '',
        },
        floor: {
            name: 'ชั้นที่',
            placeholder: 'ชั้นที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        village: {
            name: 'หมู่บ้าน',
            placeholder: 'หมู่บ้าน',
            required: '',
            too_short: '',
            invalid: '',
        },
        number: {
            name: 'เลขที่',
            placeholder: 'เลขที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        moo: {
            name: 'หมู่ที่',
            placeholder: 'หมู่ที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        soi: {
            name: 'ซอย',
            placeholder: 'ซอย',
            required: '',
            too_short: '',
            invalid: '',
        },
        road: {
            name: 'ถนน',
            placeholder: 'ถนน',
            required: '',
            too_short: '',
            invalid: '',
        },
    },
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        terms: "Terms And Conditions",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",
    },
    campaign: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
    },
    detail: {
        detail: 'Details',
        condition: 'Conditions',

        point_unit: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        available_date: 'Date',
        expire_date: 'Expire date : {0}',

        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },
        select: 'ตัวเลือก :',

        amount: 'Amount',
        add_cart: 'Add to cart',
        buy_now: 'Buy now',
        distributed_by: 'Distributed by',
        delivery_to: 'Delivery to',
        edit_address: 'Edit adress',
        free: 'Free',
        also_like: 'You may also like',
        share: 'Share',
        page_link: 'URL Link',
        copy: 'Copy',
        copied: 'Copied'
    },
    history: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',

        parcel_number: 'Parcel No. : ',
    },
    error_code: {
        code_412: 'token is invalid',
        code_campaignId: 'campaign id is invalid',
        code_cat_id: 'category id is invalid',
        code_agency_id: 'agency id is invalid',
        code_target_page: 'target page is invalid'
    },
    otp: {
        otp_code: 'ONE TIME PASWORD (OTP)',
        otp_phone: 'One Time Password (OTP) has been delivered to the number.',
        refcode: 'Ref.Code',
        plz_input_otp: '',
        minute: '',
        resend_otp: 'Resend OTP',
        time_remain: 'OTP will expire within ',
        err_otp: 'รหัสไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
        err_code: 'Error Code :',
        btn_ok: 'Confirm',
        btn_cancel: 'Cancel'
    },
    topbar: {
        label: {
            signup: 'SIGN UP',
            login: 'LOG IN'
        },
        dont_have_account: "Don't have an account?",
        have_account: 'ฉันมีบัญชีผู้ใช้แล้ว',
        login: 'LOG IN',
        register: 'Sign up',
        search: {
            placeholder: 'Search...',
            topSearch: 'Popular search'
        }
    },
    footer: {
        fast_delivery: 'Domestic express delivery',
        tracking: 'Track delivery status <br> every step',
        safe_payment: 'Secure payment',
        warranty: 'Guarantee products <br> are genuine',
        payment_method: 'Payment Methods',
        delivery_service: 'Delivery Services',
        power_by:'Powered By',
        shopdd: {
            title: 'ShopDD',
            contact: 'Contact Us',
            tracking: 'Delivery Tracking',
            faq: 'FAQ',
            news: 'Nes&Activities',
        },
        policy: {
            title: 'Policy',
            condition: 'Term&Condition',
            privacy: 'Data Privacy Notice',
            cookie: 'Cookie Policy',
        },
        customer: {
            title: 'Customer Service',
            office_hour: 'Everyday 09.00 A.M. - 05.30 P.M.',
            tel: 'Phone no: +662 760 3988',
            email_label: 'eMail: ',
            email: 'support@buzzebees.com',
            market_copyright: '© B2B Marketplace 2023',
        },
        shop_detail: '<p>As online shopping becoming more prevalent now, B2B Marketplace Thai is always striving to keep up with what the consumers want and need. We are making every effort to achieve maximum customer satisfaction through seamless transactions and competitive product pricing. We are updating and improving our product selection at the best prices to delight our customers along with catchy deals, flash sales, and other cool promos.</p>',
        copyright: '© Copyright 2023 BUZZEBEES. All Rights Reserved',
    },
    btn_back: 'Back',
    B2B: {
        home: {
            ends_in: "จบใน",
            see_more: "ดูทั้งหมด",
            brand: "ร้านค้า",
            category: "หมวดหมู่"
        },
        search: {
            placeholder: "ค้นหา",
            cancel: "ยกเลิก",
        },
        campaign: {
            point: "{0} คะแนน",
            price: "฿ {0}",
            detail: "รายละเอียด",
            condition: "เงื่อนไขการใช้งาน",
            add_to_cart: "ใส่ตะกร้า",
            item_added: "เพิ่มสินค้าในตะกร้าสำเร็จ",
        },
        flashsale: {
            item_count_sold: "ขายแล้ว {0} ชิ้น",
            buy_now: "ซื้อเลย",
            expire: "ขออภัย แคมเปญนี้ได้สิ้นสุดระยะเวลาแล้ว",
            close: "ปิด"
        }
    },
    forgetpassword: {
        forgetpassword: 'FORGET PASSWORD',
        mobileNumber: {
            name: 'Mobile Phone Number (Registered)',
            placeholder: '',
            required: 'Please enter mobile number',
            too_short: '',
            invalid: 'format mobile number invalid',
        },
        err_nodata: 'Your phone number is not found, Please check again.'
    },
    side_menu : {
        profile: 'My Profile',
        changePassword: 'Change Password',
        my_wishlist: 'My Wishlist ({0})',
        my_order: 'My Order',
        contact_us: 'Contact Us',
        fag: 'Frequently Asked Questions (FAQ)',
        language: 'Change Language',
        privacy_setting: 'Personal Data Management',
        terms_conditions: 'Terms & Conditions',
        privacy_policy: 'Privacy Policy',
        marketing_message: 'Marketing Policy on use of Personal Data ',
        unconsent: 'Unsubscribe',
        logout: 'Logout'
    },
    unconsent_popup: {
        title: 'Unsubscribe!',
        msg: 'If you would like to delete an account please contact the call center every day 09.00 A.M. - 05.30 P.M.',
        tel: '02-760-3988'
    },
    logout_popup: {
        title: 'Log out',
        msg: 'Do you confirm log out?',
        btnCancel: 'Cancel',
        btnOk: 'Confirm'
    },
    home: {
        flashsale_end: 'Ends In',
        seemore: 'See More',
        buy_again: 'Buy Again',
        voucher: 'ShopDD Discount code',
        condition: 'Condition',
        get_code: 'Claim',
        brand: 'Brands',
        category: 'Categories',
        my_wishlist: 'MY WISHLIST'
    },
    search: {
        search: 'Search',
        pop_search: 'Popular search',
    },
    err_network: 'Cannot connect the network, Please check your network.',
    page: {
        home: 'Home',
        search: 'Search'
    },
    alert_popup: {
        login: {
            title: 'เข้าสู่ระบบ',
            msg: 'กรุณาล็อกอินเข้าสู่ระบบ',
            btnOk: 'เข้าสู่ระบบ',
            btnCancel: 'ยกเลิก'
        }
    }
};
